import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, Button } from 'reactstrap';
import { close } from 'redux/modules/modals/actions';

class Wrapper extends Component {
    render() {
        const modalClasses = `${this.props.className}`;
        const backdropValue = this.props.staticBackground ? 'static' : true;
        const { close } = this.props;
        return (
            <div
                onKeyUp={(e) => {
                    if (e.key === 'Escape') {
                        close();
                    }
                }}
                tabIndex={0}
                className="d-flex justify-content-center align-items-center"
            >
                <Modal style={{ height: '95vh' }} className={modalClasses} isOpen={true} fade={false} backdrop={backdropValue}>
                    <ModalBody>
                        <Button style={{ height: 20 }} className="close" onClick={close}>
                            <span aria-hidden="true">×</span>
                        </Button>
                        {this.props.children}
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default connect(
    null,
    { close }
)(Wrapper);
